"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Harvest = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var Resources_1 = require("../../Resources");
var CardRequirements_1 = require("../CardRequirements");
var Harvest = (function (_super) {
    __extends(Harvest, _super);
    function Harvest() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.HARVEST,
            tags: [Tags_1.Tags.PLANT],
            cost: 4,
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.greeneries(3); }),
            metadata: {
                cardNumber: 'X37',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.megacredits(12);
                }),
                description: 'Requires that you have 3 greenery tiles in play. Gain 12 M€.',
            },
        }) || this;
    }
    Harvest.prototype.play = function (player) {
        player.addResource(Resources_1.Resources.MEGACREDITS, 12, { log: true });
        return undefined;
    };
    return Harvest;
}(Card_1.Card));
exports.Harvest = Harvest;
